import { render } from "./popup.vue?vue&type=template&id=2ee711f1"
import script from "./popup.js?vue&type=script&lang=js&external"
export * from "./popup.js?vue&type=script&lang=js&external"

import "./popup.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__